/* eslint-disable */
import * as PIXI from 'pixi.js';

const state = {
  bank: {}
};

const mutations = {
  ADD(state, payload) {
    if (!state.bank[payload.file.id]) {
      
      let baseTexture;
      
      if(!payload.spritesheet) {
        baseTexture = new PIXI.BaseTexture(payload.tag, {});

        const texture = new PIXI.Texture(baseTexture);
        state.bank[payload.file.id] = {url:payload.file.src, texture:texture};
      }
      else {
        new PIXI.Loader()
          .add(payload.file.src)
          .load( (loader, resource) => {
            console.log("-loaded-spritesheet-", payload.file.id);
            state.bank[payload.file.id] = { url: payload.file.src, spritesheet: resource[payload.file.src].spritesheet};
          });
      }
    }
  },
};

const actions = {};

const getters = {
  bank: state => state.bank,
  byId: state => id => state.bank[id],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
